import { useTheme } from '@/providers/theme-provider';
import { cn } from '@/lib/utils';

interface ThemeLogoProps {
  className?: string;
  alt?: string;
}

export function ThemeLogo({ className, alt = 'TrackV16' }: ThemeLogoProps) {
  const { theme } = useTheme();

  const logoSrc =
    theme === 'dark' ? '/dark-track-v16-logo.png' : '/white-track-v16-logo.png';

  return (
    <img
      src={logoSrc}
      alt={alt}
      className={cn('transition-opacity duration-200', className)}
    />
  );
}
